module.exports = __webpack_public_path__ + "static/media/ricaricaSIM.6ba276b8.svg";